import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { CreatePriceInput, StripePrice } from "./types";
import { CATALOG_PRICES_QUERY_KEY } from "./use-prices-list";

async function createPrice(input: CreatePriceInput): Promise<StripePrice> {
  return httpClient<StripePrice>("/api/admin/catalog/prices", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function useCreatePrice() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPrice,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CATALOG_PRICES_QUERY_KEY });
    },
  });
}
